uniform vec3 uStart;        // 出現位置（天球上）
uniform vec3 uDir;          // 飛行方向（単位ベクトル）
uniform float uProgress;    // 0→1 の飛行進捗
uniform float uFlightDist;  // 飛行距離
uniform float uTrailLength; // 尾の長さ
uniform float uPixelRatio;
uniform float uSizeScale;   // 流星群バースト時に太くする倍率（通常 1.0）

attribute float aTrail;     // 0 = 先頭, 1 = 尾の末端

varying float vAlpha;

void main()
{
  // 先頭からの距離に応じて各点を配置し、流星のストリークを作る
  float head = uProgress * uFlightDist;
  float pointDist = max(head - aTrail * uTrailLength, 0.0);
  vec3 pos = uStart + uDir * pointDist;

  vec4 viewPosition = viewMatrix * vec4(pos, 1.0);
  gl_Position = projectionMatrix * viewPosition;

  // 出現時と消滅時をなめらかにするエンベロープ
  float envelope = sin(clamp(uProgress, 0.0, 1.0) * 3.14159);
  vAlpha = (1.0 - aTrail) * envelope;

  gl_PointSize = (3.0 - aTrail * 2.0) * uSizeScale * uPixelRatio * (30.0 / -viewPosition.z);
}
